import TextArea from "common/Inputs/TextArea";
import { TextAreaProps } from "antd/es/input";
import styled, { css } from "styled-components";
import { hexToRGB } from "@shared/utils/misc";
import * as React from "react";
import { CSSProperties } from "react";
import Text from "common/Typography/Text";
import Card from "common/Boxes/Card";
import { FixMeLater } from "types";

interface TextAreaWithTitleProps extends TextAreaProps {
  title: string;
  innerRef?: FixMeLater;
  wrapperStyle?: CSSProperties;
  usePointerCursor?: boolean;
  onClick?: () => void;
}

const TextAreaWithTitle = ({
  title,
  innerRef,
  wrapperStyle,
  usePointerCursor,
  onClick,
  ...props
}: TextAreaWithTitleProps) => {
  return (
    <Wrapper
      style={wrapperStyle}
      $usePointerCursor={!!usePointerCursor}
      onClick={onClick}
    >
      <TextAreaTitle>{title}</TextAreaTitle>
      <StyledTextArea
        {...props}
        spellCheck="false"
        variant="borderless"
        ref={innerRef}
      />
    </Wrapper>
  );
};

export default TextAreaWithTitle;

const Wrapper = styled(Card)<{ $usePointerCursor: boolean }>`
  width: auto;
  height: auto;
  position: relative;
  padding: 16px 0;
  .ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn
    .ant-input-clear-icon {
    right: 20px;
  }
  ${(p) =>
    p.$usePointerCursor &&
    `
    cursor: pointer;
    textarea {
      cursor: pointer;
      pointer-events: none;  
    }
  `}
  ${(p) =>
    p.theme.isNewLook &&
    css`
      /* New look: a titled text field (field border, hover and focus ring). */
      padding: 12px 0 8px;
      border: 1px solid ${p.theme.colors.lightBorderGrey};
      border-radius: ${p.theme.radii.control + 2}px;
      box-shadow: none;
      transition: border-color 150ms, box-shadow 150ms;
      &:hover {
        border-color: ${p.theme.colors.mediumBorderGrey};
      }
      &:focus-within {
        border-color: ${p.theme.colors.primaryBlue};
        box-shadow: 0 0 0 3px ${hexToRGB(p.theme.colors.primaryBlue, 0.14)};
      }
    `}
`;
const TextAreaTitle = styled(Text).attrs((p) => ({
  color: p.theme.isNewLook
    ? p.theme.colors.secondaryText
    : p.theme.colors.primaryBlue,
}))`
  padding-left: 24px;
  ${(p) =>
    p.theme.isNewLook &&
    `
    padding-left: 14px;
    font-size: 12.5px;
    font-weight: ${p.theme.typography.fontWeights.MEDIUM};
  `}
`;
const StyledTextArea = styled(TextArea)`
  .ant-input {
    padding: 4px 24px;
  }
  ${(p) =>
    p.theme.isNewLook &&
    `
    &.ant-input,
    .ant-input {
      padding: 4px 14px;
      font-variant-numeric: tabular-nums;
    }
  `}
`;
